import type { RelativeDateTime } from 'cadenza/relative-date-time/relative-date-time';
import type { RelativeDateTimeInterval } from 'cadenza/relative-date-time/relative-date-time-interval';

export function isClassicRelativeDateTime (relativeDateTimeOrInterval: RelativeDateTime | RelativeDateTimeInterval): relativeDateTimeOrInterval is RelativeDateTime {
  // Amount is present only on RelativeDateTime
  return Object.prototype.hasOwnProperty.call(relativeDateTimeOrInterval, 'amount');
}
